import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    SubportionStateMachineConfigurationCreateRequest, SubportionStateMachineConfigurationPatchInBatchRequest,
    SubportionStateMachineConfigurationResponse
} from '@/modules/configurationModule/detail/local-laboratory-module/subportion-state-machines/services/configuration-subportion-state-machines/configuration-subportion-state-machines.dto'

class SubportionStateMachineConfigurationService {
    async create(laboratoryId: number, request: SubportionStateMachineConfigurationCreateRequest): Promise<SubportionStateMachineConfigurationResponse> {
        const response = await axios.post<SubportionStateMachineConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/subportionStateMachineConfigurations/`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<SubportionStateMachineConfigurationResponse>> {
        const response = await axios.put<IResponseAgGrid<SubportionStateMachineConfigurationResponse>>(`/configuration/laboratories/${laboratoryId}/subportionStateMachineConfigurations/`, { ...filterModel }, { params })
        return response.data
    }

    async get(assaygroupLaboratoryId: number, laboratoryId: number): Promise<SubportionStateMachineConfigurationResponse> {
        const response = await axios.get<SubportionStateMachineConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/subportionStateMachineConfigurations/${assaygroupLaboratoryId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/subportionStateMachineConfigurations/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: SubportionStateMachineConfigurationPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/subportionStateMachineConfigurations/batch`, request)
        return response.data
    }
}

export const subportionStateMachineConfigurationService = new SubportionStateMachineConfigurationService()
